import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.mobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    this.lastScrollTop = 0
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
    this.frame = null
  }

  scroll() {
    if (!this.mobile || this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = null
      const top = document.documentElement.scrollTop
      if (top > this.lastScrollTop) {
        this.element.style.top = `-${this.element.offsetHeight}px`
      } else if (top < this.lastScrollTop - 5) {
        this.element.style.top = "0"
      }
      this.lastScrollTop = top
    })
  }
}
